import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@mui/material'

const CustomBtn = styled(Button)`
    background: ${props => props.bgc ? props.bgc : "linear-gradient(to top, #050C24, #2A355D)"};
    font-size: 12px;
    border-radius: 20px;
    font-family: ${props=> props.fm ? props.fm : "PoppinsSB"};
    /* margin:  0 5px; */
    color:#fff;
    border: ${props => props.b ? props.b : "none"};
    box-shadow: ${props => props.bs ? props.bs : "inset 1px 3px 3px #406BFF"};
    transition: .5s;
    text-transform: none;
    cursor: ${props => props.cur ? props.cur : "pointer"};
    z-index: 1;
    :hover{
      background: #406BFF;
      box-shadow: none;
    }
    @media(max-width:599px){
      font-size: ${props=> props.fs599};
  }

`

const CustomButton = (props) => {
  const {children} = props
  return (
    <CustomBtn variant='filled' {...props}>
        {children}
    </CustomBtn>
  )
}

export default CustomButton